import {FC} from 'react';
import {FormField} from 'ui';
import {DocumentPhotoSlotValue, ResidenceDocumentScreenConfig} from '../../model';
import {StepLayout} from 'features/registration';
import {PassportPhotoUpload} from '../components/PassportPhotoUpload/PassportPhotoUpload';
import {TextInput} from '../components/TextInput';
import styles from './ResidenceDocumentStep.module.css';

type Props = {
	config: ResidenceDocumentScreenConfig;
	values: DocumentPhotoSlotValue;
	address: string;
	onAddressChange: (address: string) => void;
	onPhotoSelect: (file: File) => void;
	onPhotoRemove: () => void;
};

/** Отдельный экран сразу после налогового идентификатора, если проживание не в РФ. */
export const ResidenceDocumentStep: FC<Props> = ({
	config,
	values,
	address,
	onAddressChange,
	onPhotoSelect,
	onPhotoRemove,
}) => {
	return (
		<StepLayout>
			<StepLayout.Title>{config.title}</StepLayout.Title>

			<StepLayout.Content className={styles.content}>
				<div className={styles.uploadBlock}>
					<p className={styles.subtitle}>{config.subtitle}</p>
					<PassportPhotoUpload
						previewUrl={values.previewUrl}
						onSelect={onPhotoSelect}
						onRemove={onPhotoRemove}
					/>
				</div>

				<div className={styles.hints}>
					<p>Документом, подтверждающим место проживания, может являться:</p>
					<p>- разрешение на проживание</p>
					<p>- сертификат налогового резидентства в этой стране</p>
				</div>

				{config.requireAddress ? (
					<FormField label="Адрес проживания">
						<TextInput
							name="residenceAddress"
							multiline
							value={address}
							placeholder="До номера квартиры"
							autoComplete="street-address"
							onChange={(event) => onAddressChange(event.target.value)}
							onClear={() => onAddressChange('')}
						/>
					</FormField>
				) : null}
			</StepLayout.Content>
		</StepLayout>
	);
};
